import { render, staticRenderFns } from "./MatchFileAttaching.vue?vue&type=template&id=bb31705e&scoped=true&"
import script from "./MatchFileAttaching.vue?vue&type=script&lang=js&"
export * from "./MatchFileAttaching.vue?vue&type=script&lang=js&"
import style0 from "./MatchFileAttaching.vue?vue&type=style&index=0&id=bb31705e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb31705e",
  null
  
)

export default component.exports